const style = {
  wrapper: {
    position: `absolute`,
    right: `-180px`,
    top: `132px`,
    height: `150px`,
    padding: `35px 20px`,
    border: `1px solid #ddd`,
    borderRadius: `3px`
  },
  label: {
    fontSize: `16px`,
    fontWeight: 300,
    paddingTop: `6px`
  },
  value: {
    fontSize: `50px`,
    fontWeight: 400,
    lineHeight: `50px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Statistics/style/cpm.js